// Identify which button was clicked on form submission.
const ApplyButtonState = {
  mounted(this: any) {
    const target = this.el.dataset.target || "tracking-submit-input";
    const hiddenInput = <HTMLInputElement>document.querySelector(`#${target}`);
    this.el.addEventListener("mouseenter", (e: any) => {
      if (hiddenInput) hiddenInput.value = e.target.getAttribute("name");
    });
  },
};

export default ApplyButtonState;
